import ImmersionToggle from 'components/ImmersionToggle/ImmersionTogglePresentation'

export default ImmersionToggle
